/**
 * 拡張アップロード機能のエントリーポイント
 * MapLifeシステムに統合するためのメインファイル
 */

// 必要なモジュールを直接require方式で読み込み
require('./progressBar');
require('./heicSupport');
require('./advancedImageUploader');
require('../maplifeCommon/enhancedUpload');

// 初期化関数
function initializeEnhancedUpload() {
  console.log('Enhanced Upload System initialized');
  console.log('Features:');
  console.log('- HEIC/HEIF → JPEG conversion');
  console.log('- Client-side image optimization');
  console.log('- Progress bar display');
  console.log('- Concurrent uploads');
  console.log('- Error handling');
}

// DOM読み込み完了時に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeEnhancedUpload);
} else {
  initializeEnhancedUpload();
}

// デモ関数（テスト用）
window.testEnhancedUpload = function() {
  // ファイル入力要素を作成してテスト
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.multiple = true;
  
  input.onchange = async function(e) {
    const files = Array.from(e.target.files);
    
    try {
      if (files.length === 1) {
        // 単一ファイル
        if (window.enhancedRegistPicture) {
          await window.enhancedRegistPicture({
            file: files[0],
            checkSpot: 'test',
            success: (result) => {
              console.log('Test upload success:', result);
              alert('アップロード成功！');
            },
            error: (error) => {
              console.error('Test upload error:', error);
              alert('アップロードエラー: ' + error.message);
            }
          });
        }
      } else {
        // 複数ファイル
        if (window.bulkUploadFiles) {
          const results = await window.bulkUploadFiles(files, {
            checkSpot: 'test'
          });
          console.log('Bulk test upload results:', results);
          alert(`${results.length}個のファイルのアップロードが完了しました！`);
        }
      }
    } catch (error) {
      console.error('Test error:', error);
      alert('テストエラー: ' + error.message);
    }
  };
  
  input.click();
};

export default initializeEnhancedUpload;